var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 2.57143H14.1429V0H1.92857C0.865286 0 0 0.865286 0 1.92857C0 2.32971 0 14.7857 0 14.7857C0 15.8503 0.864 16.7143 1.92857 16.7143H16.7143C17.424 16.7143 18 16.1383 18 15.4286V3.85714C18 3.14743 17.424 2.57143 16.7143 2.57143ZM1.92857 2.57143C1.57371 2.57143 1.28571 2.28343 1.28571 1.92857C1.28571 1.57371 1.57371 1.28571 1.92857 1.28571H12.8571V2.57143H10.2857H1.92857ZM16.7143 11.5714H13.5C12.4354 11.5714 11.5714 10.7074 11.5714 9.64286C11.5714 8.57829 12.4354 7.71429 13.5 7.71429H16.7143V11.5714Z",
    fill: "url(#paint0_linear_54_1118)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 10.2857C13.8553 10.2857 14.1431 9.9979 14.1431 9.64286C14.1431 9.28782 13.8553 9 13.5003 9C13.1452 9 12.8574 9.28782 12.8574 9.64286C12.8574 9.9979 13.1452 10.2857 13.5003 10.2857Z",
    fill: "url(#paint1_linear_54_1118)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_1118",
    x1: 3.13043,
    y1: 19.102,
    x2: 18.3095,
    y2: 0.249157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDCD86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_54_1118",
    x1: 13.081,
    y1: 10.4694,
    x2: 14.2641,
    y2: 9.1049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDCD86"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.229df516ea12d92aa1b45dbb40daddcd.svg";
export { ForwardRef as ReactComponent };